export const ADD_TRACKED_ASSET = 'Dyzio/TrackAssetModal/ADD_TRACKED_ASSET';

export const SET_TRACKED_ASSET_DATA = 'Dyzio/TrackAssetModal/SET_TRACKED_ASSET_DATA';



/** WEBPACK FOOTER **
 ** ./src/containers/track-asset-modal/constants.js
 **/